import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class BracketTradeUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.placeBracketTrade(req);
    }
}
export default BracketTradeUseCase;
